export default __webpack_public_path__ + "static/media/lesnik_winter_b_01.ab240544.svg";